export default __webpack_public_path__ + "static/media/m1918-bar.3debb450.svg";